import * as actions from "actions/location";

export default (state = null, { type, payload }) => {
  switch (type) {
    case actions.DELETE_ONE_SUCCESS:
    case actions.DELETE_ONE: {
      return null;
    }

    case actions.DELETE_ONE_FAILED: {
      return payload.error;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/location/deleteErrors.js